import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=1ff63bed&scoped=true&"
import script from "./InstagramFeed.vue?vue&type=script&lang=ts&"
export * from "./InstagramFeed.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramFeed.vue?vue&type=style&index=0&id=1ff63bed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff63bed",
  null
  
)

export default component.exports